module.exports = __webpack_public_path__ + "img/banner2_9_th.3862cf8c.png";